import React from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as EmptyStateIllustration } from "assets/illustrations/empty-business-compliance-illustration.svg";
import { useIndividualCompliance } from "contexts/individual-compliance-context";

import { Loader } from "ui/loader";
import { Paragraph2, Paragraph3 } from "ui/typography";

interface IEmptySelectedIndividualProps {
  message?: string;
  padding?: string;
}

export const EmptySelectedIndividual = (
  props: IEmptySelectedIndividualProps
) => {
  const { individualComplianceUILoading } = useIndividualCompliance();
  const { message, padding } = props;

  return (
    <Box
      className="p-6 rounded-[20px] bg-white h-full flex justify-center items-center"
      css={{
        boxShadow: "0px 0px 5px 0px #0000000D",
        padding: padding || "",
      }}
    >
      {individualComplianceUILoading ? (
        <Loader hideLoadingText />
      ) : (
        <Box className="h-[191px] flex flex-col items-center gap-3">
          <Box>
            <EmptyStateIllustration />
          </Box>
          <Box className="h-[78px] flex flex-col gap-2">
            <Paragraph2
              fontWeight="700"
              lineHeight="25.6px"
              textColor="#1A202C"
              className="text-center"
            >
              Nothing to see here
            </Paragraph2>
            <Paragraph3
              lineHeight="22.4px"
              textColor="#718096"
              className="text-center w-[289px] whitespace-normal"
            >
              {message ||
                "No individuals to review right now. Please check back later."}
            </Paragraph3>
          </Box>
        </Box>
      )}
    </Box>
  );
};
